/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_dashboard_balances_activate_button = /** @type {(inputs: {}) => string} */ () => {
	return `Activa tu tarjeta Visa`
};

const en_dashboard_balances_activate_button = /** @type {(inputs: {}) => string} */ () => {
	return `Activate your Visa card`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const dashboard_balances_activate_button = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dashboard_balances_activate_button(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("dashboard_balances_activate_button", locale)
	if (locale === "es") return es_dashboard_balances_activate_button(inputs)
	return en_dashboard_balances_activate_button(inputs)
};
export { dashboard_balances_activate_button as "dashboard.balances.activate_button" }